import { useSelector } from 'react-redux'
import { RootState } from '../store'

export const useAuth = () => {
  const { user, token, isAuthenticated, isLoading } = useSelector((state: RootState) => state.auth)
  const isAdmin = Boolean(user?.is_super_admin || user?.role === 'owner' || user?.role === 'admin')
  
  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    isAdmin,
    canEdit: isAdmin || user?.role === 'editor',
    isManager: user?.is_manager === true,
  }
}
